import {
  _cel,
  _gattr,
  _qs, _qsa
} from '../js/shortJS'

// function requireAll (r) {
//   r.keys().forEach(r)
// }
// requireAll(require.context('./svg/', true, /\.svg$/))

const doc = document
const win = window
const usedSVG = {}

;(async function () {
  if (!win.spriteIconsUrl) return
  const fullListOfIcons = await win.fetch(win.spriteIconsUrl).then(res => res.text())

  if (!fullListOfIcons) {
    return
  }

  const isARSupport = window.CSS.supports('aspect-ratio', '1/1')

  const fullListOfIconsWrapper = doc[_cel]('div')
  fullListOfIconsWrapper.innerHTML = fullListOfIcons

  const getIcon = (iconID) => {
    const symbol = fullListOfIconsWrapper[_qs](iconID)

    if (!symbol) return false

    const vb = symbol[_gattr]('viewBox')
    const sVB = vb.split(' ')

    usedSVG[iconID] = {
      ar: `${sVB[2]}/${sVB[3]}`,
      heightCoef: sVB[3] / sVB[2],
      widthCoef: sVB[2] / sVB[3],
      html: `<svg height="100%" width="100%" viewBox="${vb}">${symbol.innerHTML}</svg>`,
      assets: []
    }

    // add assets
    for (const el of symbol[_qsa]('[fill^="url"]')) {
      const id = el[_gattr]('fill').replace('url(', '').replace(')', '')

      if (id) {
        const asset = fullListOfIconsWrapper[_qs](id)
        asset && usedSVG[iconID].assets.push(asset)
      }
    }

    return true
  }

  class ComponentSpriteSVG extends HTMLElement {
    constructor () {
      super()
      this.shadow = this.attachShadow({ mode: 'open' })
    }

    updateShadowSVG () {
      if (!usedSVG[this.iconID] && !getIcon(this.iconID)) return
      const svg = usedSVG[this.iconID]

      if (isARSupport) {
        this.style.aspectRatio = svg.ar
      }

      this.shadow.innerHTML = svg.html
      if (svg.assets.length > 0) {
        this.shadow.querySelector('svg').append(...svg.assets.map(asset => asset.cloneNode(true)))
      }
    }

    recalculateSize (heightCoef, widthCoef) {
      this.removeAttribute('style')

      const sizesObj = window.getComputedStyle(this)
      const width = parseInt(sizesObj.width)
      const height = parseInt(sizesObj.height)

      if (!isNaN(height)) {
        this.style.width = `${Math.floor(height * widthCoef)}px`
      } else if (!isNaN(width)) {
        this.style.height = `${Math.floor(width * heightCoef)}px`
      }
    }

    attributeChangedCallback (name, oldValue, newValue) {
      if (name === 'data-icon') {
        if (oldValue === newValue) return
        this.iconID = newValue.includes('#') ? newValue : '#' + newValue
        this.updateShadowSVG()
      }
    }

    static get observedAttributes () {
      return ['data-icon']
    }

    connectedCallback () {
      if (isARSupport) return

      setTimeout(() => {
        const svg = usedSVG[this.iconID]
        this.recalculateSize(svg.heightCoef, svg.widthCoef)
      }, 300)
    }
  }
  window.customElements.define('s-svg', ComponentSpriteSVG)
}())
